<script>
	let { labelLeft, labelBottom, content, bar, class: className } = $props();
</script>

<div class={[className, 'flex w-full flex-row']}>
	<div class="flex w-7 items-center justify-center">
		<span
			class="
     rotate-180 text-sm font-medium text-indow-grey-medium
     [writing-mode:vertical-rl]
   "
		>
			{labelLeft}
		</span>
	</div>

	<div class="grow">
		<ul
			class="
     mt-3 mb-0 flex w-full list-none flex-col gap-2 border-l
     border-indow-grey-dark pt-3 pb-6 text-right font-bold text-white
   "
		>
			{#each content as { percent, title, color }, index (index)}
				<li
					style={`width:${percent}%`}
					class={[
						'p-3',
						{
							'bg-indow-grey': color === 'grey',
							'bg-indow-grey-medium': color === 'grey-medium',
							'bg-indow-grey-dark': color === 'grey-dark',
							'bg-indow-blue': color === 'blue',
							'bg-indow-yellow': color === 'yellow',
							'bg-indow-white': color === 'white',
						},
					]}
				>
					{title}
				</li>
			{/each}
		</ul>
		<!-- eslint-disable better-tailwindcss/no-unknown-classes -->
		<ul
			class="
     ticks m-0 flex list-none flex-row justify-between text-sm font-medium
   "
		>
			<!-- eslint-enable better-tailwindcss/no-unknown-classes -->
			{#each bar as b, index (index)}
				<li
					class="
       border-t border-indow-grey-dark
       max-sm:even:[&_span]:opacity-0
     "
				>
					<span>{b}</span>
				</li>
			{/each}
		</ul>
		<p class="text-left text-sm font-medium text-indow-grey-medium">
			{labelBottom}
		</p>
	</div>
</div>

<style>
	.ticks li {
		position: relative;
		padding-top: 0.25rem;
		width: 100%;
	}
	.ticks li:not(:first-child) span {
		display: inline-block;
		transform: translateX(-50%);
	}
	.ticks li:after {
		content: '';
		position: absolute;
		height: 0.5rem;
		width: 1px;
		right: 0;
		top: -0.5rem;
		background-color: black;
	}
	.ticks li:last-child:after {
		visibility: hidden;
	}
	.ticks li:last-child {
		border: none;
		width: auto;
	}
</style>
